export const areAllCheckoutRowsSelected = (selectedIds, rows, getSelectionKey) => {
    const rowIds = new Set(
        (Array.isArray(rows) ? rows : []).map((row) => getSelectionKey(row))
    );
    return Array.from(rowIds).every((id) => selectedIds.has(id));
};
